import ModalV2 from "../ModalV2";
import MethodSystemProvider from "./MethodSystemProvider";

export default function MethodSystem({ networks, contracts, currencies, operators, reloadMethods }) {
  return (<ModalV2 name="method-system" className="w-[800px] h-[1020px] flex flex-col">
    <MethodSystemProvider networks={networks} contracts={contracts} currencies={currencies} operators={operators} reloadMethods={reloadMethods} />
  </ModalV2>)
}